export default {
    GET_OWNER_USERS_REQUEST: 'COURSES_BULK_UPDATE_GET_OWNER_USERS_REQUEST',
    GET_OWNER_USERS_SUCCESS: 'COURSES_BULK_UPDATE_GET_OWNER_USERS_SUCCESS',
    UPDATE_COURSES_REQUEST: 'COURSES_BULK_UPDATE_UPDATE_COURSES_REQUEST',
    UPDATE_COURSES_SUCCESS: 'COURSES_BULK_UPDATE_UPDATE_COURSES_SUCCESS',
    DISPOSE: 'COURSES_BULK_UPDATE_DISPOSE_STORE',
};
